export function fmtTime(seconds: number): string {
  if (!isFinite(seconds) || seconds < 0) return '0:00';
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

export function parseTime(input: string): number | null {
  // Accept "mm:ss", "m:ss", "ss", "1.5", "90s"
  const trimmed = input.trim();
  if (!trimmed) return null;
  if (trimmed.includes(':')) {
    const [m, s] = trimmed.split(':').map((p) => parseFloat(p));
    if (isNaN(m) || isNaN(s)) return null;
    return m * 60 + s;
  }
  const n = parseFloat(trimmed.replace(/s$/i, ''));
  return isNaN(n) ? null : n;
}

export function fmtRelativeDate(iso: string): string {
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return 'just now';
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  if (diff < 86400 * 7) return `${Math.floor(diff / 86400)}d ago`;
  return d.toLocaleDateString(undefined, { month: 'short', day: 'numeric' });
}

export function fmtMoney(cents: number, currency = 'usd'): string {
  return new Intl.NumberFormat(undefined, {
    style: 'currency',
    currency: currency.toUpperCase(),
  }).format(cents / 100);
}

// Stem display: icon + capitalized label. Matches the extension's labels.
export const STEM_META: Record<string, { icon: string; label: string }> = {
  vocals: { icon: '🎤', label: 'Vocals' },
  drums: { icon: '🥁', label: 'Drums' },
  bass: { icon: '🎸', label: 'Bass' },
  piano: { icon: '🎹', label: 'Piano' },
  guitar: { icon: '🎶', label: 'Guitar' },
  other: { icon: '✨', label: 'Solo & Lead' },
};

export const STEM_ORDER = ['vocals', 'drums', 'bass', 'piano', 'guitar', 'other'] as const;
export type StemName = (typeof STEM_ORDER)[number];

export function stemLabel(name: string): string {
  return STEM_META[name]?.label ?? name;
}

export function stemIcon(name: string): string {
  return STEM_META[name]?.icon ?? '🎵';
}
